// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2023-11-30 19:34:28 +0100 (Thu, 30 Nov 2023) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 139224 $
//  Purpose   : wrap sui modal
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Modal as SuiModal} from 'semantic-ui-react'

import {useFullscreenContext} from 'uix/hooks'

const Modal = ({...props}) => {
  let {domNode} = useFullscreenContext()
  return <SuiModal {...props} mountNode={domNode || undefined} />
}
Modal.Content = SuiModal.Content
Modal.Actions = SuiModal.Actions
Modal.Description = SuiModal.Description
Modal.Dimmer = SuiModal.Dimmer
Modal.Header = SuiModal.Header

export {Modal}
